import * as React from 'react';
import { Typography, Stack, Modal, Box, Button } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { selectPaymentMethods, clearCardType, selectPaymentState } from '../sagas/residentpaymentsSlice';
import HelpIcon from '@mui/icons-material/Help';
import AddCardIcon from '../../../icons/addcard.png';
import PaymentMethodComp from './PaymentMethodComp';
import useMediaQuery from '@mui/material/useMediaQuery';
import CloseModalIcon from '../../../icons/RoundCloseIcon.svg';
import AddNewCardPaymentModal from '../../../shared/Modal/AddNewCardPaymentModel';
import AddNewBankPaymentModal from '../../../shared/Modal/AddNewBankPaymentMethod';
import { clearBankAndCardStates } from '../sagas/residentpaymentsSlice';
import BankIcon from '../../../icons/Bank_Icon.svg';
import CardIcon from '../../../icons/Card_Icon.svg';
import PaymentMethodIcon from '../../../icons/PaymentsMethodsIcon.svg';
import SpinnerWithNoConfirmation from '../../../shared/Modal/spinnerWithNoConfirmation';
import { selectAuthState } from '../../../shared/sagas/auth/authSlice';
import { selectAvailablePaymentMethods } from '../../../pmui/residents/saga/pmResidentsSlice';
import { useInosioUser } from '../../../shared/login/useInosioUser';
import { PaymentMethodsDTO } from '@inosio/payments-sdk';
import { useEffect, useState } from 'react';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: '#FFFFFF',
  boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
  p: 2,
};

export default function PaymentMethodsTile(props: any) {
  const dispatch = useDispatch();
  const matchesMobile = useMediaQuery('(max-width:600px)');

  //local states
  const [addPayMethod, setOpenAddPayMethod] = useState(false);
  const [openCardModal, setOpenCardModal] = useState(false);
  const [openBankModal, setOpenBankModal] = useState(false);
  const [currentPaymentMethods, setCurrentPaymentMethods] = useState<PaymentMethodsDTO>({ BankAccounts: [], BankCards: [] });
  const [allMethods, setAllMethods] = useState<any[]>([]);

  //selectors
  const { isPaymentMethodsFailed, isFetchingPaymentMethods } = useSelector(selectPaymentState);
  const { ipaUser } = useSelector(selectAuthState);
  const [isInosioUser] = useInosioUser();
  const adhocPaymentMethods = useSelector(selectAvailablePaymentMethods);
  const savedPaymentMethods = useSelector(selectPaymentMethods);

  useEffect(() => {
    if (ipaUser?.currentProfile?.isActing && !isInosioUser) {
      setCurrentPaymentMethods({
        BankAccounts: [...(adhocPaymentMethods?.BankAccounts ?? []), ...(savedPaymentMethods?.BankAccounts ?? [])],
        BankCards: [...(adhocPaymentMethods?.BankCards ?? []), ...(savedPaymentMethods?.BankCards ?? [])],
      });
    } else {
      setCurrentPaymentMethods({
        BankAccounts: savedPaymentMethods?.BankAccounts ?? [],
        BankCards: savedPaymentMethods?.BankCards ?? [],
      });
    }
  }, [adhocPaymentMethods, savedPaymentMethods]);

  const handleOpenAddPaymentMethod = () => {
    setOpenAddPayMethod(true);
  };

  const handleCloseAddPayMethod = () => {
    setOpenAddPayMethod(false);
  };

  const handleOpenCardModal = () => {
    setOpenAddPayMethod(false);
    setOpenCardModal(true);
  };
  const handleOpenBankModal = () => {
    setOpenAddPayMethod(false);
    setOpenBankModal(true);
  };
  const handleCloseCardModal = () => {
    setOpenCardModal(false);
    dispatch({
      type: clearCardType.type,
    });
    dispatch({
      type: clearBankAndCardStates.type,
    });
  };
  const handleCloseBankModal = () => {
    setOpenBankModal(false);
    dispatch({
      type: clearBankAndCardStates.type,
    });
  };
  const handleCloseGoBackCardModal = () => {
    setOpenCardModal(false);
    dispatch({
      type: clearCardType.type,
    });
    dispatch({
      type: clearBankAndCardStates.type,
    });
  };
  const handleCloseGoBackBankModal = () => {
    setOpenBankModal(false);
    dispatch({
      type: clearBankAndCardStates.type,
    });
  };

  useEffect(() => {
    if (currentPaymentMethods) {
      const filteredBankAccountsPayments = currentPaymentMethods.BankAccounts.map((method) => {
        const bankWallet = { ...method };
        return bankWallet;
      });
      const filteredBankCardsPayments = currentPaymentMethods.BankCards.map((method) => {
        let ccWallet = null;
        let dcWallet = null;
        if (method?.CardType === 'CC') {
          ccWallet = { ...method };
        }
        if (method?.CardType === 'DB') {
          dcWallet = { ...method };
        }
        return { ...ccWallet, ...dcWallet };
      });

      const methods = [...filteredBankAccountsPayments, ...filteredBankCardsPayments];
      methods.sort((a: any, b: any) => (a?.CreatedDate > b?.CreatedDate ? -1 : a?.CreatedDate < b?.CreatedDate ? 1 : 0));
      setAllMethods(methods);
    }
  }, [currentPaymentMethods]);

  useEffect(() => {
    if (isPaymentMethodsFailed) {
      props.handleFailure();
    }
  }, [isPaymentMethodsFailed]);

  return (
    <React.Fragment>
      <Stack direction="column" justifyContent="space-between" alignItems="space-between" spacing={2}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} style={{ width: '100%' }}>
          <div>
            <Typography id="paymentMethodTitle">
              My Wallet <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />{' '}
            </Typography>
          </div>
          <div>
            <img
              style={{
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
              src={AddCardIcon}
              alt="add card"
              onClick={handleOpenAddPaymentMethod}
            />

            {/* choosing modal */}
            <Modal open={addPayMethod} onClose={handleCloseAddPayMethod} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <Box
                sx={{
                  ...style,
                  maxWidth: matchesMobile ? '100%' : '472px',
                  width: matchesMobile ? '100%' : 'calc(100% - 64px)',
                  height: matchesMobile ? '100%' : '523px',
                  borderRadius: matchesMobile ? 'none' : '24px',
                }}
              >
                <Stack direction="column" justifyContent="space-between" alignItems="space-between" spacing={2}>
                  <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                    <Typography id="payment-method-title">Payment Method Type</Typography>
                    <div>
                      <img src={CloseModalIcon} alt="close" style={{ cursor: 'pointer' }} onClick={handleCloseAddPayMethod} />
                    </div>
                  </Stack>

                  <Stack direction="row" justifyContent="center" spacing={2} style={{ marginTop: '25%' }}>
                    <Stack direction="column" alignContent={'center'}>
                      <Box>
                        <img src={CardIcon} alt="card" />
                      </Box>
                      <Box>
                        <Button variant="contained" id="add-card-btn" onClick={handleOpenCardModal}>
                          Add Card
                        </Button>
                      </Box>
                    </Stack>
                    <Stack direction="column" alignContent={'center'}>
                      <Box>
                        <img src={BankIcon} alt="bank" />
                      </Box>
                      <Box>
                        <Button style={{ marginRight: '12px' }} variant="contained" id="add-bank-modal-btn" onClick={handleOpenBankModal}>
                          Bank Account
                        </Button>
                      </Box>
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            </Modal>
          </div>
        </Stack>
        {matchesMobile ? (
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
            <div style={{ width: '100%', maxWidth: 370 }}>
              {isFetchingPaymentMethods ? (
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                  style={{
                    marginTop: '50px',
                  }}
                >
                  <SpinnerWithNoConfirmation />
                </Stack>
              ) : allMethods.length !== 0 ? (
                <PaymentMethodComp methods={allMethods} />
              ) : (
                <Stack justifyContent="center" alignItems="center" spacing={2}>
                  <img src={PaymentMethodIcon} alt="history" width="226px" height="267px" />
                  <Typography>My Wallet</Typography>
                </Stack>
              )}
            </div>
          </Stack>
        ) : (
          <div style={{ width: '100%' }}>
            {isFetchingPaymentMethods ? (
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                style={{
                  marginTop: '50px',
                }}
              >
                <SpinnerWithNoConfirmation />
              </Stack>
            ) : allMethods.length !== 0 ? (
              <PaymentMethodComp methods={allMethods} />
            ) : (
              <Stack justifyContent="center" alignItems="center" spacing={2}>
                <img src={PaymentMethodIcon} alt="history" width="132px" height="116px" />
                <Typography>My Wallet</Typography>
              </Stack>
            )}
          </div>
        )}
      </Stack>
      {openCardModal ? (
        <AddNewCardPaymentModal handleCloseCardModal={handleCloseCardModal} openCardModal={openCardModal} handleCloseGoBackCardModal={handleCloseGoBackCardModal} smallVersion={true} />
      ) : (
        <></>
      )}

      {openBankModal ? (
        <AddNewBankPaymentModal handleCloseBankModal={handleCloseBankModal} openBankModal={openBankModal} handleCloseGoBackBankModal={handleCloseGoBackBankModal} smallVersion={true} />
      ) : (
        <></>
      )}
    </React.Fragment>
  );
}
